import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/views/home/index.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    // component: () => import('@/views/home/index.vue')
    component: Home
  },
  {
    path: '/oauth',
    name: 'oauth',
    component: () => import('@/views/oauth/index.vue')
  },
  { // 3D模型页面
    path: '/three/:floder?',
    name: 'Three',
    component: () => import('@/views/three/index.vue')
  },
  { // 账户页面
    path: '/accountPage',
    name: 'AccountPage',
    component: () => import('@/views/accountPage/index.vue')
  },
  { // 支付页面
    path: '/puchaseCredits',
    name: 'PuchaseCredits',
    component: () => import('@/views/puchaseCredits/index.vue')
  },
  // { // 收银台页面
  //   path: '/cashierdesk',
  //   name: 'CashierDesk',
  //   component: () => import('@/views/cashierdesk/index.vue')
  // }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  // history: createWebHashHistory(),
  // history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.name != 'home' && !localStorage.getItem('token')) {
    if (to.name == 'oauth') { // 白名单
      next();
    } else {
      // 如果用户未登录，重定向到登录页面
      next('/');
    }
  } else {
    // 否则，继续导航
    next();
  }
})

export default router
